import { Typography } from "@mui/material";
import { shortenUrl } from "../../../../../Infrastructure/Services/ShortUrlService";
import { EnvelopeIcon } from "../../../Icon/EnvelopeIcon";
import { FacebookIcon } from "../../../Icon/FacebookIcon";
import { LinkIcon } from "../../../Icon/LinkIcon";
import React from "react";
import { ServiceModalOption } from "../ServiceModal.types";
import { ServiceModalOptionsList } from "../ServiceModalOptions.component";
import { SERVICE_MODALS_OPTIONS_STATES } from "../../ServiceFunctionsModal.types";

export default function SharingContent(
    groupId: string,
    postId: string,
    shortLink: string,
    setShortLink: (short: string) => void,
    groupName: string,
    showMobileSharingOptions: boolean,
    setModalCurrentAction: (state: SERVICE_MODALS_OPTIONS_STATES) => void,
) {
    if (showMobileSharingOptions) {
        return;
    }
    if (shortLink == "") {
        shortenUrl(groupId, postId)
            .then((data) => {
                setShortLink(data.short);
            })
            .catch(() => {
                setModalCurrentAction(
                    SERVICE_MODALS_OPTIONS_STATES.UNSUCCESSFUL_SHORTENING_SHARING_LINK,
                );
            });
    }

    const mailSubject = encodeURI(`Die CHECK24-Tippspiel Community`);

    const mailBody = `Entdecke neue Community Beiträge aus der Gruppe ${groupName} ᛫ ${encodeURI(
        shortLink,
    )}`;

    const sharingOptions: ServiceModalOption[] = [
        {
            headline: `E-Mail`,
            icon: <EnvelopeIcon />,
            isDisabled: shortLink == "",
            onOptionClickHandler: () => {
                window.location.href = `mailto: ?subject=${mailSubject}&body=${mailBody}`;
            },
        },
        {
            headline: "Facebook",
            icon: <FacebookIcon />,
            isDisabled: shortLink == "",
            onOptionClickHandler: () => {
                window.open(
                    `https://www.facebook.com/share.php?u=${shortLink}`,
                    "_blank",
                );
            },
        },
        {
            headline: "Link kopieren",
            icon: <LinkIcon />,
            isDisabled: shortLink == "",
            onOptionClickHandler: () => {
                if (window.isSecureContext) {
                    navigator.clipboard
                        .writeText(shortLink)
                        .then(() => {
                            setModalCurrentAction(
                                SERVICE_MODALS_OPTIONS_STATES.SHARING_LINK_COPIED_SUCCESSFULLY,
                            );
                        })
                        .catch(() => {
                            setModalCurrentAction(
                                SERVICE_MODALS_OPTIONS_STATES.UNSUCCESSFUL_COPYING_SHARING_LINK,
                            );
                        })
                        .finally(() => {
                            setShortLink("");
                        });
                } else {
                    setModalCurrentAction(
                        SERVICE_MODALS_OPTIONS_STATES.UNSUCCESSFUL_COPYING_SHARING_LINK,
                    );
                    setShortLink("");
                }
            },
        },
    ];
    const modalTitle = <Typography>Teilen</Typography>;
    const modalContent = <ServiceModalOptionsList options={sharingOptions} />;
    return { modalTitle, modalContent };
}
